module.exports = __webpack_public_path__ + "img/examples-img01.8fa98de4.jpg";